<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      d="M18 20C17.6844 20 17.4029 19.8538 17.2197 19.6254L13.3237 15.7295L13.2405 15.6353C12.9355 15.243 12.9632 14.6757 13.3237 14.3153L13.4179 14.2321C13.8102 13.927 14.3774 13.9548 14.7379 14.3153L17 16.5778V4L17.0067 3.88338C17.0645 3.38604 17.4872 3 18 3C18.5523 3 19 3.44772 19 4V16.5941L21.3014 14.2929L21.3956 14.2097C21.7879 13.9047 22.3551 13.9324 22.7156 14.2929C23.1061 14.6834 23.1061 15.3166 22.7156 15.7071L18.7156 19.7071L18.6214 19.7903C18.4404 19.931 18.2222 20.0009 18.0042 20L18 20Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M2 16.4C2 15.6268 2.6268 15 3.4 15H5.1C5.8732 15 6.5 15.6268 6.5 16.4V18.1C6.5 18.8732 5.8732 19.5 5.1 19.5H3.4C2.6268 19.5 2 18.8732 2 18.1V16.4ZM3.6 17.9V16.6H4.9V17.9H3.6Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M8.9 15C8.1268 15 7.5 15.6268 7.5 16.4V18.1C7.5 18.8732 8.1268 19.5 8.9 19.5H10.6C11.3732 19.5 12 18.8732 12 18.1V16.4C12 15.6268 11.3732 15 10.6 15H8.9ZM9.1 16.6V17.9H10.4V16.6H9.1Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V12C12 13.1046 11.1046 14 10 14H4C2.89543 14 2 13.1046 2 12V6ZM4 6H10V12H4L4 6Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
